import { Component, Input } from '@angular/core';
import {
  AmlScanEntity,
  AmlWalletData,
  FirstReportData,
  LatestAmlReport,
  ReportData,
  ReportEntity,
  Top10Data
} from '../../../api/api.model';
import TransactionReportComponent from './components/transaction-report/transaction-report.component';
import YourFirstReportComponent from './components/your-first-report/your-first-report.component';
import Top10ReportComponent from './components/top-10-report/top-10-report.component';
import { AmlWalletReportComponent } from './components/aml-wallet-report/aml-wallet-report.component';

@Component({
  selector: 'app-reports',
  imports: [
    TransactionReportComponent,
    YourFirstReportComponent,
    Top10ReportComponent,
    AmlWalletReportComponent
  ],
  templateUrl: './reports.component.html',
  styleUrl: './reports.component.scss'
})
export class ReportsComponent {
  @Input()
  public report!: ReportEntity<any>;

  @Input()
  public transaction!: AmlScanEntity<LatestAmlReport>;

  asFirstReportData(report: ReportEntity<ReportData>): ReportEntity<FirstReportData> {
    return report as ReportEntity<FirstReportData>
  }

  asTop10Data(report: ReportEntity<ReportData>): ReportEntity<Top10Data> {
    return report as ReportEntity<Top10Data>
  }

  asAmlWalletData(report: ReportEntity<ReportData>): ReportEntity<AmlWalletData> {
    return report as ReportEntity<AmlWalletData>
  }
}
